import { useTranslation } from "react-i18next";
import { DealerMap } from "@/components/site/DealerMap";
import { StandalonePageShell } from "@/components/site/StandalonePageShell";
import { useSiteContent } from "@/lib/useSiteContent";

export default function DealerNetworkPage() {
  const { t } = useTranslation();
  const home = useSiteContent("home");
  const contact = useSiteContent("contact");
  const dealers = useSiteContent("dealers");

  return (
    <StandalonePageShell
      content={{ home, contact, dealers }}
      eyebrow={t("pages.network.eyebrow")}
      title={t("pages.network.title")}
      description={t("pages.network.description")}
    >
      <div data-testid="dealer-network-page">
        <DealerMap />
      </div>
    </StandalonePageShell>
  );
}
